import { AlertCircle, Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { trpc } from '~/api/trpc';
import { Alert, AlertDescription, AlertTitle } from '~/components/ui/alert';
import Content from '~/components/layout/Content';
import MetabaseDashboard from '~/components/metabase/MetabaseDashboard';

const PractitionerDashboard = () => {
    const {
        data,
        isLoading,
        error,
    } = trpc.analytics.getMetabaseDashboardToken.useQuery(undefined, {
        refetchInterval: 8 * 60 * 1000,
        retry: false,
    });

    useEffect(() => {
        const handler = (event: MessageEvent) => {
            console.log('[Metabase postMessage]', event.origin, event.data);
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    if (isLoading) {
        return (
            <Content className="flex items-center justify-center min-h-[400px]">
                <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </Content>
        );
    }

    if (error) {
        return (
            <Content>
                <h1 className="text-3xl font-bold mb-6">Behandler Dashboard</h1>
                <Alert variant="destructive">
                    <AlertCircle className="h-4 w-4" />
                    <AlertTitle>Dashboard nicht verfügbar</AlertTitle>
                    <AlertDescription>
                        {error.message === 'Kein Metabase-Dashboard für diesen Benutzer konfiguriert.'
                            ? 'Für diesen Benutzer wurde kein Dashboard konfiguriert. Bitte wenden Sie sich an einen Administrator.'
                            : error.message}
                    </AlertDescription>
                </Alert>
            </Content>
        );
    }

    if (!data) return null;

    return (
        <Content noPadding>
            <div className="p-6 pb-0">
                <h1 className="text-3xl font-bold">Behandler Dashboard</h1>
            </div>
            <MetabaseDashboard
                token={data.token}
                instanceUrl={data.instanceUrl}
                withTitle={false}
                withDownloads
                initialParameters='{"zeitraum":"past3months~","granularit%C3%A4t":"month"}'
            />
        </Content>
    );
};

export default PractitionerDashboard;
